export const temporaryEn = {
  // add english strings here
  // you do not need to use en: { }, thats assumed
  wordsQueued: "Queued",
  wordsScheduled: "Scheduled",
  wordsRecent: "Recent",
  success: "Success",
  taskScheduledSuccessMessage: "Task scheduled successfully",
  itWillRunOn: "It will run on {date}",
  itWillRunEvery: "It will run every {interval}",
  nextRun: "Next run is on {date}",
  runsEvery: "Runs every {interval}",
  seePendingTasks: "See pending tasks",
  scheduledFor: "Scheduled for {date}",
  editTaskTitle: "Edit Task",
  taskUpdateSuccess: "Task updated successfully",
  timeAm: "AM",
  timePm: "PM",
  pastDateError: "Date must be in the future",
  scheduleThisTask: "Schedule This Task",
  update: "Update",
  regenerate: "Regenerate",
  thumbsDown: "This is bad",
  thumbsUp: "This is good",
  noScheduledTasks: "No scheduled content",
  noScheduledTasksInfo:
    "Once you schedule a task, it will appear here. Click the button below to get started.",
  wordsImmediate: "Immediate",
  days: "days",
  hours: "hours",
  minutes: "minutes",
  cronExpression: "Cron expression",
  wordsUse: "Use",
  wordsProductsAndServicesPlaceholder: "Your products and services (separate by commas)",
  messages: "Messages",
  wordsOpen: "Open",
  wordsWelcome: "Welcome",
  wordsTakingTooLong: "Taking too long?",
  runningSubTasks: "Running {count} sub-tasks",
  linksUsed: "Links used",
  wordsArticle: "Article",
  following: "Following",
  followers: "Followers",
  joined: "Joined",
  posts: "Posts",
  visitWebsite: "Visit Website",
  wordsIntegrations: "Integrations",
  noActiveMessageText: "Select a message to view its content",
  wordsSystem: "System",
  noMessageResponseText: "Sorry, this message has no response",
  continueIntegration: "Continue Integration",
  unsupportedPlatformError: "Unsupported platform: {platform}",
  integrationError: "Failed to integrate with the selected platform. Please try again.",
  existingIntegrationDetected: "Existing {platform} Integration Detected",
  confirmIntegration: "Integrate {platform} Account",
  existingIntegrationMessage:
    "You already have a {platform} integration connected. Before continuing, make sure you're signed into the {platform} account that matches this social URL. If you need to switch accounts, please sign out first. Your posts will be published to the newly connected {platform} account.",
  newIntegrationMessage:
    "When you continue, we'll connect whichever {platform} account you're currently signed into in your browser. This connected account will be used when you select it to publish your posts. To ensure we connect the correct account, check that you're signed into the {platform} account that matches this social URL. If you're signed into a different account, please sign out before continuing.",
  integrationInProgress: "Integration already in progress for {platform}",
  wordsRefreshing: "Refreshing",
  logoutMessage: "Signing out, please wait",
  authErrorMessage: "There was an error signing you in, please try again",
  signedInAs: "Signed in as",
  wordsNoAccount: "No account",
  wordsManageAccounts: "Manage accounts",
  wordsViewAll: "View all",
  wordsSwitchAccount: "Switch account",
  confirmAccountSwitch: "Are you sure you want to switch to {account}?",
  accountSwitched: "Account switched",
  buttonsAddAccount: "Add Account",
  noAccounts: "No accounts",
  accountDeleted: "Account deleted",
  confirmAccountDeletion: "Are you sure you want to delete this account?",
  wordsAccounts: "Accounts",
  addTenantAccountDescription: "Fill the details to add your new account",
  acknowledgeCompanyAuthorized: "I acknowledge that I am authorized by this company",
  startFreeTrial: "Start Free Trial",
  freeTrialTitle: "Start 14 day free trial",
  freeTrialDescription: "Try now & decide later. No credit card required",
  accountFreeTrialInfo: "You're currently on a free trial, upgrade for full access",
  tenantWelcomeMessage: "Let's set up your first account",
  createFirstAccount: "Create your first account",
  accountListDescription: "Add and manage up to {count} accounts",
  tenantBackToAppLink: "Back to {companyName} Marketing Assistant",
  aboutYourCompany: "Tell us about your company",
  moreAboutYourCompany: "Tell us a little more about your company",
  editPost: "Edit Post",
  clearAll: "Clear All",
  onboardingStepError:
    "There was an error getting the required steps. Please click the button to try again",
  wordsOn: "On",
  wordsOff: "Off", // wordsOff,Off
  taskCompleteNotificationTitle: "Completed Tasks",
  taskCompleteNotificationDescription:
    "Be notified through email when a task finishes executing.",
  notificationsUpdated: "Notifications Updated",
  myNotifications: "My Notifications",
  wordsGeneral: "General",
  errorGettingPlans: "There was an error getting the plans, please try again.",
  wordsFiles: "Files",
  wordsAbout: "About",
  wordsSocial: "Social",
  socialInstagram: "Instagram",
  socialLinkedin: "Linkedin",
  notAvailable: "Not available",
  paymentFailedTitle: "Payment failed",
  paymentFailedDescription:
    "Your last payment attempt was unsuccessful. Click the manage subscription button below to manage your subscription",
  onboardingSuccessText: "You're all set",
  invalidSocialUrl: "Invalid {type} url",
  formsName: "Name",
  upload: "Upload",
  uploading: "Uploading",
  uploadFile: "Upload File",
  noFilesTitle: "No files",
  noFilesDescription: "Upload files to get started",
  unAuthorizedError: "You are not authorized to perform this action",
  upgradeToBusinessPlan: "Upgrade to Business plan",
  businessPlan: "Business Plan",
  businessPlanUpgradeSuffix: "and get up to 3 companies in one account",
  whyUpgrade: "Why should you upgrade to the business plan?",
  upgradeReasonIntro: "The business plan gives you:",
  upgradeInfo: "You will be taken to the checkout page to complete the upgrade",
  customPlanUpgradePre: "Switch to a custom plan",
  customPlanUpgradeSuffix: "to increase your account limit",
  seeOptions: "See options",
  customPlans: "Custom Plans",
  customPlansSubtitle: "Your account limit is {limit}, you're upgrading to:",
  maximumCustomPlansLimit: "Maximum limit for custom plans is {count}",
  minimumCustomPlansLimit: "Minimum limit for custom plans is {count}",
  minMaxCustomPlansLimit: "Please select a number between {min} and {max}",
  accountsMoreThanNewLimit: "Plan limit can't be less than the number of active accounts",
  alreadyOnPlanError: "You are already on this plan",
  wordsActive: "Active",
  wordsDismiss: "Dismiss",
  wordsReload: "Reload",
  pwaUpdateMessage: "New content available. Click the reload button to update",
  wordsDowngrade: "Downgrade",
  wordsUpgrade: "Upgrade",
  wordsCompetitorsTitle: "Tell us more about your organization's competitors",
  wordsCompetitors: "Competitors",
  wordsCompetitorsDescription:
    "Keep us up-to-date with relevant info about your organization's competitors",
  websites: "Websites",
  taskResultFeedbackTitle: "How satisfied are you with the result?",
  changeLanguage: "Change Language",
  onboardingCompleteTitle: "Onboarding Complete",
  requiredValidationMessage: "{field} is required",
  greetingGoodMorning: "Good Morning",
  greetingGoodAfternoon: "Good Afternoon",
  greetingGoodEvening: "Good Evening",
  howCanBotHelpToday: "How can I help you today?",
  defaultSuggestionDescription: "Enter the details of your task and let's get started",
  defaultSuggestionTitle: "What do you need help with?",
  scheduleNextTask: "Schedule your next task",
  clearSchedule: "Clear schedule",
  processing: "Processing",
  complete: "Complete",
  wordsInterval: "Interval",
  socialYoutube: "Youtube",
  socialThreads: "Threads",
  freeTrialScheduledTaskInfo:
    "Upgrade your plan to gain access to scheduling features for tasks.",
  wordsDisabled: "disabled",
  freeTrialDaysLeft: "{daysLeft} day left",
  freeTrialDaysLeftPlural: "{daysLeft} days left",
  cancellationPendingBannerTitle: "Subscription Cancellation Pending",
  cancellationPendingBannerDescription:
    "Your subscription is going to be canceled on {cancelAtDate}. Renew your subscription to continue using Marketing Assistant.",
  renew: "Renew",
  addCompetitor: "Add Competitor",
  editCompetitor: "Edit Competitor",
  competitorsUpdated: "Competitors Updated",
  newCompetitorWillBeAddedAfterVerify:
    "New competitor websites will appear once they have been verified.",
  notice: "Notice",
  reset: "Reset",
  fineTuningLabel: "Fine Tuning",
  fineTuningDescription: "Adjust the behavior of the assistant to fit your needs",
  pagesIdentified: "{number} pages identified",
  confirmSocialLinkDeletion: "Are you sure you want to remove this {platform} link?",
  confirmCompetitorDeletion: "Are you sure you want to remove this competitor?",
  suggestions: "Suggestions",
  suggestionsSubHeading: "Here are some suggestions for you",
  noSuggestions: "No suggestions",
  noSuggestionsInfo:
    "Nothing to show yet. Helpful marketing tips tailored for {companyName} are on the way!",
  wordCategory: "Category",
  wordTags: "Tags",
  errorLoadingSuggestions:
    "There was an error loading your suggestions. Please try again",
  wordAccept: "Accept",
  subPages: "Sub pages",
  lastVisited: "Last Visited",
  preferenceSaved: "Preference Saved",
  wordsDecline: "Decline",
  websiteCrawlEventDescription: "Your website will be scanned for relevant content",
  competitorWebsiteCrawlEventDescription:
    "Your competitors' websites will be scanned for relevant content that can be used to improve your content",
  frequencyWithDay: "Runs {frequency} on {day}",
  frequencyDaily: "Runs daily",
  socialMediaCrawlEventDescription:
    "Your social media platforms will be scanned for relevant content.",
  competitorSocialMediaCrawlEventDescription:
    "Your competitors' social media platforms will be scanned for relevant content that can be used to improve your content",
  suggestionsSystemActivityDescription:
    "Your company and competitor data will be analyzed daily to bring you fresh marketing insights!",
  noRecentConversationsTitle: "No recent conversations",
  noRecentConversationsDescription: "Start a conversation to get started",
  addSocialAccount: "Add Social Account",
  accountType: "Account Type",
  wordsDate: "Date",
  wordsTime: "Time",
  myCompany: "My Company",
  websiteDetails: "Website Details",
  noNewContent: "No new content",
  latestContent: "Latest content",
  systemActivities: "System Activities",
  myActivities: "My Activities",
  accountSocialPageTitle: "{platform} Account Details",
  competitorSocialPageTitle: "Competitor {platform} Account Details",
  socialPlatformPosts: "{platform} Posts",
  planUpgradeSuccessMessage: " Plan has been Upgraded Successfully",
  lastPageCrawlFailed: "Last page visit failed",
  basicInformation: "Basic Information",
  suggestionRatingLabel: "How would you rate this suggestion?",
  suggestionRatingFeedback:
    "Thanks for your feedback! It helps us make your insights better!",
  bad: "Bad",
  noSocialPlatformPosts: "No {platform} posts",
  noSocialPlatformPostsDescription:
    "There are no posts from the last 30 days. New posts will appear here once available.",
  socialPageNotFound: "Sorry, the profile couldn't be found. Please check back later.",
  ratePost: "Rate post",
  usePostContent: "Use post content",
  usePageContent: "Use page content",
  useWebsiteData: "Use website data",
  usePageDate: "Use page date",
  websiteProcessingDescription:
    "The page is processing. Please come back in a minute or 2 to see the results.",
  externalLink: "External link",
  planAndBilling: "Plan & Billing",
  v2InputAreaPlaceholder: "Click here to start typing",
  comingSoon: "Coming Soon",
  socialMedia: "Social Media",
  fineTuning: "Fine Tuning",
  similarToYourWebsite: "Similar to your website",
  numPages: "{number} pages",
  addNew: "Add New",
  lastAccessed: "Last Accessed",
  anywhereToSkip: "Click anywhere to skip",
  hello: "Hello",
  websitePending: "The website is being verified. We will begin processing shortly",
  later: "Later",
  builtWith: "Built with {platform}",
  allPages: "All Pages",
  retryingMessage: "Request sent. We will retry shortly",
  missingPageDataRetry: "Missing data. Revisit page?",
  myAssistant: "My Assistant",
  wordsAccountUpdated: "Account Updated",
  noCompetitors: "No Competitors",
  addCompetitorsDescription: "Add competitors and let's help you get an edge",
  websiteLabel: "Website",
  files: "Files",
  deleteFileTitle: "Delete File",
  fileDeleted: "File Deleted",
  deleteConfirmationMessage: "Are you sure you want to delete {filename}",
  usePageData: "Use Page Data",
  noPages: "No Pages",
  noPagesfound: "No pages found for this website",
  discovered: "Discovered {timeAgo}",
  postDetails: "{platform} post details",
  notifications: "Notifications",
  noNotifications: "No Notifications",
  wordsPost: "Post",
  everything: "Everything",
  company: "Company",
  profile: "Profile",
  wordsAll: "All",
  mailSubject: "Subject",
  mailSidebarInfo: "Send task requests to your assigned email address",
  mailResultInfo: "Once your task is created, the result will be in the response",
  socialAccountSelect: "Select type of social account",
  facebookReel: "Facebook Reel",
  facebookReels: "Facebook Reels",
  instagramReel: "Instagram Reel",
  selectPostType: "Select post type",
  regularPost: "Regular Post",
  reelsPostingNote:
    "Reels are optimized for short-form video content and will appear in the Reels section",
  mustBeUniqueCompetitor: "Must be a unique competitor",
  cannotUseSocialMediaUrl:
    "Social media URLs are not allowed. Please enter a website URL",
  resize: "Resize",
  reels: "Reels",
  recentSearches: "Recent Searches",
  foundResults: "Found {number} results",
  images: "Images",
  facebookReelDetails: "Facebook reel details",
  profileDetails: "{platform} account details",
  webpageDetails: "Webpage details",
  wordsResearch: "Research",
  wordsQuery: "Query",
  researchDescription:
    "Provide a query about your company and let's research and let you know how you rank against your competitors, and your general approval rating on the internet.",
  createFirstQuery: "Create your first query",
  newQuery: "New query",
  companyRank: "Company rank",
  competitorRank: "Competitor rank",
  favorableResults: "Favorable results",
  wordsReason: "Reason",
  noReasonValidationError: "At least one reason must be selected",
  wordsPricing: "Pricing",
  workingOnQuery: "Working on your query",
  wordsResults: "Results",
  appearances: "Appearances",
  favorablePercent: "Favorable result percentage",
  errorOccurredTryAgain: "An error occurred. Please try again later.",
  authWordsSignOutDescription: "Signing you out",
  processingPages: "Processing pages",
  accountWebsiteProcessed: "All pages processed for website {url}",
  accountPageProcessed: "Website page, {url}, successfully processed",
  accountLinkedinCompanyProcessed: "Account LinkedIn company discovered",
  accountSocialPostsProcessed: "Account {platform} posts discovered",
  accountSocialProfileProcessed: "Account {platform} profile discovered",
  allSocialProcessed: "All account social platforms processed",
  genericSocialProcessed: "Social account discovered",
  socialPostDiscovered: "Social post discovered",
  pagesCrawledDescription: "{complete} of {total} pages complete",
  competitorWebsiteProcessed: "All pages processed for competitor website {url}",
  competitorLinkedinCompanyProcessed: "Competitor LinkedIn company discovered",
  competitorSocialPostsProcessed: "Competitor {platform} posts discovered",
  competitorSocialProfileProcessed: "Competitor {platform} profile discovered",
  allCompetitorSocialProcessed: "All competitor social platforms processed",
  allDataProcessed: "Account and competitor data discovered and reviewed",
  selectAll: "Select All",
  singleTaskDeletionMessage: "Do you want to delete this task?",
  bulkTaskDeletionMessage: "Do you want to delete these tasks?",
  taskDeletedSuccessful: "task deleted",
  canAddCompetitorMessage: "To add new Competitor, you need to upgrade your plan",
  wordsIncoming: "Incoming",
  wordsOutgoing: "Outgoing",
  featureNotAvailable: "Not available in current plan",
  CreateFacebookContent: "Create Facebook Content",
  CreateTwitterContent: "Create Twitter Content",
  CreateLinkedInPost: "Create LinkedIn Post",
  ComposeEmail: "Compose Email",
  GenerateIdeas: "Generate Ideas",
  CreateFacebookVideoScript: "Create Facebook Video Script",
  CreateContent: "Create Content",
  CreateInstagramPost: "Create Instagram Post",
  AddtextImage: "Add text, images or a URL",
  wordsPrevious: "Previous",
  wordsHelp: "Help",
  regeneratingContent: "Regenerating Content",
  updatePrompt: "Not quite what you expected? Update your prompt and try again.",
  regenerating: "Regenerating",
  onboardingCompleteDescription: "Here's overview of your account information",
  socialAccounts: "Social accounts",
  noSocialAccounts: "No social accounts",
  findHelpTipTitle: "Find help in app",
  findHelpTipText:
    "Look out for icons with a question mark (?) throughout the app. This means that you can get additional information on a topic by clicking on the icon.",
  dragImageTipTitle: "Drag & drop images when creating a task.",
  dragImageTipText:
    "When creating a task, you can drag and drop an image from your computer into the editor to add a visual representation of your task. A picture is worth a thousand words",
  didYouKnow: "Did you know?",
  updateAssistantTitle: "Update your data",
  updateAssistantTipText:
    'You can update all the details that were provided when setting up your assistant. Look for the "Brand Hub" icon in the sidebar.',
  wordsTasks: "Tasks",
  wordsAssistant: "Assistant",
  getStartedCreateTaskDescription: "Got an idea? Let's create a task.",
  getStartedIntegrationsDescription:
    "Extend your assistant by integrating with your favorite tools.",
  getStartedResearchDescription:
    "Check how your website is performing against competitors across search engines.",
  getStartedScheduleTaskDescription:
    "Want to create tasks on a schedule? Let's start here.",
  getStartedFineTuningDescription:
    "Adjust the behavior of the assistant to fit your needs.",
  getStartedDescription:
    "Welcome to your marketing assistant. Here are a few actions to get you started.",
  getStartedTodosTitle: "To-dos",
  getStartedTodosDescription: "Let's complete your set-up with these final steps.",
  addACompetitor: "Add a competitor",
  addCompetitorDescription: "Add or update the list of competitor websites.",
  addASocialAccount: "Add a social account",
  addSocialAccountDescription: "Add or update your social accounts.",
  likes: "Likes",
  inputTooShort: "Input too short",
  taskCreated: "Task created",
  createInstantTask: "Create an instant task",
  quickTaskFooter: "Create a new task using this result",
  quickTaskInputTip:
    "✨ Tip: You can edit the prompt to match exactly what you want to generate.",
  competitorInfo: "Competitor information",
  noPageSummary: "No page summary available at the moment. Please check back later",
  latestUpdates: "Latest updates",
  updateSummary: "Update summary",
  postUpdatesTitle: "Post updates",
  postUpdatesDescription:
    "Here are the summaries of the latest posts from your competitor's social accounts",
  noUpdatesSinceCheck: "No new updates since the last check",
  metrics: "Metrics",
  metricsDescription:
    "How this website has been performing over the past year(compared to yours)",
  unknownCategory: "Unknown category",
  cost: "Cost",
  traffic: "Traffic",
  keywords: "Keywords",
  keywordsAndRank: "Keywords & Rank",
  adCopies: "Ad copies",
  nothingToDisplay: "Nothing to display at the moment",
  sponsored: "Sponsored",
  profileImageQuality: "Profile images",
  okay: "Okay",
  great: "Great",
  excellent: "Excellent",
  numberOfItemsSingle: "{number} item",
  numberOfItems: "{number} items",
  settingsUsageTitle: "Usage for {currentMonthName}",
  postedTwitter: "Posted on Twitter",
  errorPostingToTwitter: "Error posting to Twitter",
  accountName: "Account Name",
  noRepost: "Tweet Already Posted",
  postLinkedIn: "Post to LinkedIn",
  postToTwitter: "Post to Twitter",
  postedLinkedIn: "Posted to LinkedIn",
  alreadyPosted: "Already Posted",
  errorPostingToLinkedIn: "Error posting to LinkedIn",
  requiredParameter: "{param} is required",
  header: "Header",
  comparePlans: "Compare",
  comparePlanLimits: "Current Plan Limits",
  planFeatures: "Plan Features",
  plan: "Plan",
  premium: "AI Suite - Agency",
  starter: "Starter",
  business: "Business",
  availableIntegrations: "Available integrations",
  taskScheduling: "Task Scheduling",
  maxCompetitors: "Maximum competitors",
  availableResearchQueries: "Available research queries",
  maxSocialAccounts: "Maximum social accounts",
  numberOfUsers: "Number of users",
  socialVisitFrequency: "Frequency of social account visits",
  websiteVisitFrequency: "Frequency of webpage visits",
  competitorWebsiteVisitFrequency: "Frequency of competitor account visits",
  billingPageDescription: "Get information about your plan, features and usage.",
  authUrlError: "Failed to get authentication URL",
  codeStateError: "OAuth connection failed - missing code or state",
  twitterConnectionError: "Twitter connection failed",
  type: "Type",
  contactSaved: "Contact saved",
  addContact: "Add contact",
  newContact: "New contact",
  newContactDescription: "Add a new contact to your account",
  contactDeleted: "Contact deleted",
  contactDeletionConfirmation: "Are you sure you want to delete {contact}?",
  contacts: "Contacts",
  contactSubHeading: "Add, update and manage your email contacts",
  contactEmptyStateText: "Select a contact to view or update their details",
  templates: "Templates",
  templateEmptyStateText: "Select a template to preview or set as default",
  contactsUploaded: "Contacts uploaded and processing",
  unsupportedFileFormat: "Unsupported file format",
  logoUploaded: "Logo uploaded",
  emailSent: "Email sent",
  emailNotSent: "Failed to send email, please try again",
  created: "Created",
  status: "Status",
  canceled: "Canceled",
  failed: "Failed",
  content: "Content",
  noNewTransaction: "No new transaction found",
  errorConnecting: "Error connecting to {platform}",
  popupClose: "popup Close",
  noAccountInfo: "No account info",
  inbox: "Inbox",
  template1Name: "New York",
  template2Name: "Hawaii",
  template1Description: "Give your emails a personality",
  template2Description: "Simple template with centered content",
  emailSetupCompleteDescription:
    "You can start using the app to send marketing emails to your contacts.",
  newMail: "New Mail",
  send: "Send",
  message: "Message",
  bulkUpload: "Bulk Upload",
  recipient: "Recipient",
  setUpEmailAlias: "Setup your alias",
  setUpEmailAliasDescription:
    "This is the address through which customers will receive your emails",
  addFirstContact: "Add your first contact",
  contactAddedToACcount: "Contact has been added to your account",
  dropCsvFile: "Drop your csv file here",
  addSingleContact: "Add a single contact",
  yourEmail: "Your email",
  yourEmailPlaceholder: "enter your email",
  recipientEmailPlaceholder: "enter the recipient email",
  emailSetupCustomDescription:
    "Add your unique email address that will be used by the platform to send your emails",
  emailSetupVerificationDescription:
    "Verification email sent. Check your mail and click the link in the email to verify. When done, come back and click the “Continue” button below.",
  emailSetupIntroTitle: "Let's get you set up",
  emailSetupIntroDescription:
    "You can use your own marketing email or go with the simple option and use a marketingassistant email. Click continue when you're ready.",
  emailSetupTypeTitle: "Setup type",
  emailSetupTypeDescription:
    "How would you want the emails to be sent with your own domain or marketingassistant.com",
  wordSimple: "Simple",
  wordCustom: "Custom",
  emailSetupSimpleDescription:
    "add an alias and send emails using your_alias@marketingassistant.com",
  sendTestEmailTitle: "Send a test email",
  sendTestEmailDescription:
    "Let's test your new email integration. Enter an email address (different from the one you've configured) to send a test mail.",
  skip: "Skip",
  selectFile: "Select file",
  activeTemplateDescription: "Your emails will look like this template when sent",
  useTemplate: "Use template",
  changeLogo: "Change logo",
  selectLogo: "Select logo",
  dropLogo: "Drop your logo here",
  activeTemplateConfirmation:
    "are you sure you want to set {activeTemplateName} as the default template?",
  templateListDescription: "Choose how your outgoing emails look and feel",
  emailMarketingModalTitle: "Introducing Email Outreach",
  emailMarketingModalDescription:
    "Reach out to your customers from right here in Marketing Assistant",
  emailMarketingModalFeature1:
    "Use a marketingassistant.com alias or your own custom email",
  emailMarketingModalFeature2: "Add and manage contacts (we support bulk uploads)",
  emailMarketingModalFeature3: "Choose a template that fits your style",
  emailMarketingModalFeature4: "Customize emails with your logo",
  emailMarketingModalSubText: "And many more features coming soon!",
  new: "New",
  researchTourStep1Description:
    "Provide a query about your company and let's research and let you know how you rank against your competitors, and your general approval rating on the internet.",
  researchTourStep2Description: "Enter your query and select your reasons",
  fineTuningTourText:
    "Adjust the behavior of your assistant, to match your business needs",
  taskTourStep1Title: "Create Your First Task",
  taskTourStep1Description:
    "Begin your path to streamlined marketing with Marketing Assistant. Simplify your efforts, save time, and create with ease. Ready to take the first step?",
  taskTourStep2Title: "Choose Your Marketing Focus",
  taskTourStep2Description:
    " Select a task category to tailor Marketing Assistant to your specific needs.",
  taskTourStep2SubDescription: "Select a category below.",
  taskTourStep3Title: "Select Your Task",
  taskTourStep3Description:
    "Zero in on what matters most for your marketing efforts today. Marketing Assistant simplifies your marketing without sacrificing results. Let's get to work.",
  taskTourStep4Title: "Let’s Start Creating!",
  taskTourStep4Description:
    "You're one step closer to reclaiming your schedule with Marketing Assistant's time-saving magic.",
  taskTourTips: "Tips to get the most from your results:",
  detailMatters: "Detail Mattters",
  detailMattersDescription: "The more precise your input,the more tailored your output.",
  planAhead: "Plan Ahead",
  planAheadDescription:
    "Schedule tasks and have results delivered straight to your inbox.",
  refineRepeat: "Refine & Repeat",
  refineRepeatDescription:
    "Each task helps Marketing Assistant learn and adapt to your needs for continually improved results.",
  streamline: "Streamline",
  streamlineDescription:
    "Combine different tasks for a seamless marketing strategy that works effectively in the background.",
  integrationTourStep1Title:
    "Extend your assistant by integrating with your favorite tools",
  integrationTourSep1SubTitle: "Social Media Integration",
  integrationTourStep1Description: "Post directly to Facebook and Instagram",
  tourContinue: "Click on the continue to setup your integration",
  sendNow: "Send Now",
  sendLater: "Send Later",
  dateAndTime: "Date and Time",
  invalidScheduleTime: "Invalid schedule time",
  emailScheduled: "Email scheduled. It will be sent at the scheduled time",
  processingLogo: "Processing new logo",
  processingContacts: "Processing new contacts",
  sendingEmail: "Processing email",
  sendingEmails: "Processing emails",
  sendingEmailAllContacts: "Sending email to all contacts",
  campaigns: "Campaigns",
  add: "Add",
  addGoal: "Add Goal",
  companyGoal: "Company Goal",
  strategicObjectives: "Strategic Objectives",
  strategicObjective: "Strategic Objective",
  addObjectives: "Add Objective",
  coreMarketingChannels: "Core Marketing Channels",
  coreMarketingChannel: "Core Marketing Channel",
  addChannel: "Channel",
  culturalConsiderations: "Cultural Considerations",
  culturalConsideration: "Cultural Consideration",
  addCulturalConsiderations: "Add Consideration",
  customerPainPoints: "Customer Pain Points",
  customerPainPoint: "customer Pain Point",
  addPoint: "Add Point",
  industryCategory: "Industry Category",
  geographicLocation: "Geographic Location",
  productsAndService: "Products And Service",
  visionAndMission: "Vision And Mission",
  vision: "Vision Statement",
  mission: "Mission Statement",
  brandPositioning: "Brand Positioning",
  politicalAffiliation: "Political Affiliation",
  politicalNonAffiliation: "Political Non Affiliation",
  callToActions: "Call to Actions",
  addCallToAction: "Add Call to Action",
  maxCallToActionsReached: "Maximum of {max} call to actions allowed",
  noCallToActions: "No call to actions available",
  hashtagGroups: "Hashtag Groups",
  hashtagGroupsDescription: "Organize your hashtags into groups for easy reuse",
  hashtagGroupNamePlaceholder: "e.g. Brand, Product, Campaign",
  addHashtagGroup: "Add Hashtag Group",
  noHashtagGroups: "No hashtag groups available",
  hashtagPlaceholder: "Enter a hashtag",
  hashtagHint: "Press Enter to add each hashtag",
  listInputHint: "Press Enter to add each item",
  wordsHashtags: "Hashtags",
  wordsGroup: "Group",
  brandIdentityTone: "Brand Identity Tone",
  selectTone: "Select Tone",
  targetAudienceOverview: "Target Audience Overview",
  targetAudienceDemographics: "Target Audience Demographics",
  gender: "Gender",
  selectGender: "Select Gender",
  education: "Education",
  ageFloor: "Minimum Age",
  ageCeiling: "Maximum Age",
  incomeFloor: "Minimum Income",
  incomeCeiling: "Maximum Income",
  companyDetails: "Company Details",
  campaignDetails: "Campaign Details",
  companyGoals: "Company Goals",
  editCampaign: "Edit Campaign",
  upToDate: "Already up to date",
  playful: "Playful",
  neutral: "Neutral",
  serious: "Serious",
  campaign: "Campaign",
  wordDefault: "Default",
  createCampaign: "Create Campaign",
  noCampaigns: "No Campaigns",
  noCampaignsDescription: "This account has no campaigns yet.",
  addFilter: "Add a Filter",
  addField: "Add a Field",
  campaignSaved: "Campaign saved",
  campaignSaveFailed: "Failed to save campaign",
  addFilterAlert: "Please add at least one filter",
  nameOfCampaign: "Name of the Campaign",
  campaignNamePlaceholder: "Enter the name of the campaign",
  accountDataPointDescription:
    "This section allows you to configure the core data points that fuel our content generation engine. The more information you provide, the more accurate and relevant the content is to your brand.",
  chooseTargetAudience: "Choose the target audience",
  deleteCampaignConfirmation: "Are you sure you want to delete this campaign?",
  campaignDeleteFailed: "Failed to delete campaign",
  campaignDeleteSuccess: "Campaign deleted",
  campaignDeleteTitle: "Delete Campaign",
  shareComingSoon: "Coming Soon",
  projectName: "Project Name",
  noProject: "No Project Found",
  emailConfigure: "Configure your email address",
  emailStep1: "Select Me to allow sending emails from the logged-in user's email",
  emailStep2:
    "Choose Email from my company domain to permit all emails from your company domain",
  emailStep3: "Select Specify List to list the allowed email addresses",
  emailNote:
    "Once the connection is successful, an email address will be generated. You can send a message to this address to create a task in Marketing Assistant",
  facebookNote: "You must have Facebook Business/Professional account to connect",
  facebookStep1: "Authorize Marketing Assistant to your facebook profession account",
  facebookStep2: "Select your Facebook Business Portfolio",
  facebookStep3: "Select your Facebook pages you want to connect",
  facebookStep4: "Review the permissions required and then click save",
  facebookStep5: "Click the Got it button to complete the connection",
  instagramNote: "You must have an Instagram Business/Professional account to connect",
  instagramStep:
    "Clicking continue will bring an Instagram auth popup for account login, then allow all requested permissions.",
  linkedInStep:
    "Clicking continue will open a LinkedIn authentication popup for account login, and you should allow all requested permissions.",
  youtubeStep:
    "Clicking continue will open a YouTube authentication popup for account login, and you should allow all requested permissions.",
  incomingHookTitle: "Configure Incoming Webhook",
  incomingHookDesc:
    "In your target Teams channel, setup an Incoming Webhook connector and then copy the generated URL and paste it into the Incoming Webhook field.",
  outgoingHookTitle: "Configure Outgoing Webhook",
  outgoingHookDesc:
    "Go to Manage Teams, on the App tab, create a new Outgoing Webhook, enter the outgoing webhook URL from the app into the callback URL, provide name (eg MaTest), then copy the security token it provides and paste that into the Token field.",
  testIntegration: "Test Integration",
  testNote:
    "In the same channel, type @YourOutgoingWebhookName(eg. @MaTest) follow by the task command. Teams will post that to the marketing assistant. Upon successful task creation, the recreated task result and a link to view the tasks on the marketing assistant will be posted as a response.",
  thinking: "Thinking",
  noContentForStep: "No content for this step",
  generating: "Generating",
  socialMediaPosts: "Social Media Posts",
  cancelSubscription: "Cancel Subscription",
  cancelSubscriptionDescription:
    "You will be taken to your portal on our secure payment provider's platform to cancel your subscription.",
  cancelSubscriptionInstructionTitle: "Cancellation instruction",
  cancelSubscriptionInstructionDescription:
    "On your payment portal, click the 'Cancel Subscription' button next to your active subscription to finalize your cancellation.",
  closeInstructions: "Close instructions",
  moreInfo: "More information",
  "social-media/wordpress/post-to-wordpress": "Post to WordPress",
  "social-media/facebook/post-to-facebook": "Post to Facebook",
  "social-media/facebook/announce-event": "Announce Event on Facebook",
  "social-media/instagram/post-to-instagram": "Post to Instagram",
  "social-media/twitter/post-to-twitter": "Post to Twitter",
  "social-media/linkedin/post-to-linkedin": "Post to LinkedIn",
  "social-media/tiktok/post-to-tiktok": "Post to TikTok",
  "social-media/youtube/post-to-youtube-video": "Post to YouTube",
  "social-media/youtube/post-to-youtube-channel-description": "Post to YouTube",
  scheduleInstagramPost: "Schedule Instagram Post",
  contentScheduled: "Content scheduled successfully",
  contentScheduleFailed: "Content scheduling failed",
  unsupportedContentType: "Unsupported content type",
  selectedContentNotFound: "Selected content not found",
  whenShouldItBePosted: "When should it be posted?",
  noContentSelected:
    "No content selected. Please select an option from the list to schedule.",
  scheduleContent: "Schedule Content",
  schedulePlatformPost: "Schedule {platform} Post",
  removeEvent: "Unschedule",
  eventRemoved: "Event removed successfully",
  eventRemoveFailed: "Failed to remove event",
  removeEventDescription:
    "The content will be removed from the calendar and will not be posted. Are you sure you want to continue?",
  clickEventInstruction: "Click the event to see more details.",
  library: "Library",
  generate: "Generate",
  insert: "Insert",
  noContentPreview: "No content preview available yet",
  noEventsForDay: "No events for this day",
  noEventsDescription:
    "Sorry, there are scheduled events for this date. You can use the button below to schedule a new one",
  createNewContentSelectTypeTitle: "What type of post do you want to schedule?",
  contentUpdated: "Content updated",
  contentUpdateFailed: "Content update failed, please try again",
  featureComingSoon: "This feature is coming soon",
  noContent: "No content",
  noContentAvailableForCategory: "No content available for the selected category",
  noPreview: "No preview available",
  modified: "Modified",
  size: "Size",
  filesAndAssets: "Files and assets",
  fileType: "File type",
  editFile: "Edit file",
  brandAndStrategy: "Brand & strategy",
  productInformation: "Product Information",
  mediaAssets: "Media Assets",
  competitorResearch: "Competitor Research",
  logo: "Logo",
  processingFile: "Processing 1 file",
  processingFiles: "Processing {number} files",
  contentNotEditable: "Sorry, this content is not editable",
  missingIntegrationTitle: "Missing integration",
  missingIntegrationDescription:
    "The integration for {platform} is either disabled or misconfigured. Click the button below to check the integration.",
  checkIntegration: "Check integration",
  selectIntegrationAccountError: "Please select an account to continue",
  export: "Export",
  contentCalendarExportInstruction:
    "Select the start and end dates of the content to export",
  contentExportDownloadInstruction:
    "Your export is ready. Use the button below to download",
  userSharedPost: "{user} shared a post",
  allFiles: "All files",
  termsAccepted: "terms accepted",
  termAndCondition: "Terms and Conditions ",
  termsAndConditionSubtitle:
    "Please review and accept our terms before using Marketing Assistant",
  termsAndConditionDescription:
    " By using this application, you agree to abide by our terms and conditions. For further details, please review our full Terms of Service.",
  termsAndConditionLink: " Read our full Terms of Service",
  termsAndConditionCheck: " I agree to the terms and conditions",
  selectIndustryCategory: "Select Industry Category",
  industryCaution: "Caution for Finance and Healthcare",
  industryCautionNote1:
    "Users please be advised that Marketing Assistant is not HIPAA-compliant and should not be used for storing or processing sensitive financial or health-related data. If you are in the healthcare or financial services industry, we recommend reviewing our ",
  industryCautionNote2:
    "to ensure our services meet your needs. By proceeding, you agree to our Terms and Conditions and acknowledge the use of Marketing Assistant for non-sensitive business data.",
  industryCategoryAcknowledged:
    "I have read and accept the Terms and Conditions and Privacy Policy and acknowledge the cautions for finance and healthcare industries set forth in Section 3 of the Terms and Conditions and Section 5 of the Privacy Policy. I further represent and warrant to Marketing Assistant that",
  industryCautionCheck: "I am not engaged in either of these industries",
  contentScheduledTitle: "Content Scheduled",
  scheduledContentDescription: "This content has been scheduled for posting.",
  openCalendar: "Open Calendar",
  selectAccount: "Select Account",
  generated: "Generated",
  smartTips: "Smart Tips",
  calendar: "Calendar",
  seeMyContent: "See My Content",
  nextUp: "Next up",
  nextStep: "Next Step",
  newOnboardingComplete: "Congrats! You've Completed Onboarding!",
  newOnboardingCompleteDesc:
    " Welcome to your new content HQ. You've just taken a huge step toward smarter, faster marketing and we're so excited to be part of your journey!",
  letGetWritingTitle:
    "Let's get writing. Your first month of content is being served up now:",
  seoWrite: "4 SEO-optimized blogs",
  socialMediaWrite: "Social media posts tailored to your brand",
  allReadyReview: "All ready to review, post, and watch your engagement grow",
  magicalPower: "Ready to see the Magical POWER of Marketing Assistant?",
  onboardingWelcome: "Welcome to Marketing Assistant!",
  onboardingWelcomeDesc:
    "You're officially on board for a revolutionary content journey—where your personal Marketing Assistant becomes your secret weapon for smarter, faster marketing.",
  readyToSaveTime: "Ready to save hours of time?",
  readyToLevelUp: "Ready to level up your content game?",
  readyToMarket: "Ready to market smarter—not harder?",
  letsGo:
    "Now's the time to turn your big ideas into powerful, on-brand content—without the stress. You bring the vision, we bring the AI. Let's go!",
  fromBlogsAndSocial:
    "From blogs and social posts to proactive website tips and competitive insights, you're about to do the work of four marketing tools in one powerful platform.",
  letsRevolutionize: "Let's revolutionize your marketing—starting now.",
  psNote:
    "P.S. In just 2 minutes, you'll have a full month's worth of content—SEO-optimized, tailored to your brand, and built to perform.",
  readyToStart: "Ready to start!",
  shareDesc: "Share a quick description that includes",
  whoAreYou: "Who you are",
  whatYouDo: "What you do",
  whenYouStart: "When you started",
  whereAt: "Where you're based",
  missionGuideNote:
    "Skip this step and then check out our Mission and Vision Guide on the Smart tip page to create your own.",
  competitiveAnalysisNote:
    "Check out our guide on Competitive Analysis on the Smart tip page",
  note: "Note",
  popupsBlockedError:
    "Popup blocked by the browser, please check your settings and retry",
  brandHub: "Brand Hub",
  errorLoadingContent: "Error loading content",
  goToOriginalContent: "Go to original content",
  planUnavailableTitle: "Plan Unavailable",
  planUnavailableDescription:
    "There have been changes to the available plans. Please check the billing page and upgrade your subscription to a new plan.",
  planUnavailableAction: "Check Plan",
  all: "All",
  months3: "3 Months",
  months6: "6 Months",
  webhookInstructions:
    "Learn more on how to Configure Incoming and Outgoing Webhook here",
  socialPlatformPost: "{platform} Post",
  noScheduledContent: "No Scheduled Content Found",
  noScheduledContentDescription:
    "Looks like nothing has been scheduled yet. Create new content or check your filters.",
  welcomeDescription:
    "Welcome to your personalized performance dashboard-powered by AI and built to help you grow.",
  ongoingProcess: "Ongoing Processes",
  oneMonthContent: "content for the next 1 month",
  writeArticle:
    "Writing articles, creating social media posts, and scheduling content for posting.",
  taskProgressStatus: "{done} of {total} done",
  more: "More",
  smartTipsQA: "Q&A Smart Tips",
  generatingMonthContent:
    "Generating a month's worth of <b>personalized</b>, <b>high quality</b> content",
  generatedMonthContent:
    "Generated a month's worth of <b>personalized</b>, <b>high quality</b> content",
  gettingReady: "Getting Ready",
  creatingContent: "Your content is being created",
  contentCreated: "Your content has been created",
  contentProgress: "Checking your content generation status, please wait.",
  tips: "Tips",
  youAreSet: "You're all set!",
  goHomeDescription:
    "You can go home while your content is generating in the background.",
  goHome: "Go Home",
  scheduledContent: "Scheduled Content",
  categories: "Categories",
  helpfulTips: "Helpful Tips",
  advanceTips: "Advanced Tips",
  frozenTips:
    "If your Marketing Assistant dashboard seems frozen, scroll to the bottom of the screen and check the version number.",
  havingTrouble: "Still having trouble?",
  submitTicket: "Submit a support ticket here",
  teamHelp: "and our team will help you out ASAP.",
  generatingContent: "Generating content",
  versionStatusRedIcon:
    "If you see a <strong>red icon</strong>, try refreshing your browser — this usually resolves the issue.",
  versionStatusGreenIcon:
    "If the icon is <strong>green</strong>, you're on the latest version.",
  researchAndCraft: "Research & Craft Your Perfect Articles",
  featuredContent: "Featured Content Creator",
  createMonth: "Create a month's worth of content in just a few minutes",
  noContentFound: "Could not find the content at this time, please try again later.",
  contentList: "Content List",
  newContent: "New content",
  selectContent: "Select Content",
  contentType: "Content Type",
  existingContent: "Existing Content",
  integrationAvailable: "integration available",
  missingIntegration: "Missing integration",
  today: "Today",
  checkOut: "Check out our Mission and Vision Guide on",
  toCreate: "to create your own.",
  checkOurGuide: "Check out our",
  guideOn: "guide on Competitive Analysis",
  createAndScheduleDesc: "Create and schedule some content and find them here",
  startATour: "Start a tour",
  websiteTraffic: "Website Traffic",
  adTraffic: "Ad Traffic",
  organicTraffic: "Organic Traffic",
  organicCost: "Organic Cost",
  integrations: "Integrations",
  reschedule: "Reschedule",
  rescheduleContent: "Reschedule Content",
  rescheduleContentDescription: "Select a new date and time for the content to be posted",
  accountNotFound: "Account not found",
  accountNotFoundDescription:
    "The account you're looking for doesn't exist or may have been removed. Please check the username and try again.",
  contentExportTypeDescription: "Do you want to export scheduled or general content?",
  contentExportPlatformDescription: "Which platform do you want to export to?",
  contentExportSocialPlatformDescription: "Which type of content do you want to export?",
  acceptNewContent: "Accept New Content",
  rejectNewContent: "Reject New Content",
  setupRequired: "Setup Required",
  setupRequiredMessage:
    "Your account is missing critical information. Please complete setup to continue",
  completeSetup: "Complete Setup",
  errorBoundaryDescription:
    "Please check your internet connection or try reloading the page.",
  genericResourceRenderError:
    "Sorry, your {resource} could not be loaded at this time, please check your internet connection or try reloading the page",
  singleTaskCrashError:
    "There's been a problem with this content, please check your internet, reload your browser, or try again with a different prompt.",
  accountStatistics: "Account Statistics",
  personal: "Personal",
  organizations: "Organizations",
  linkedInReconnect:
    "New: You can now post to LinkedIn organizations. To enable this, please disconnect and reconnect your LinkedIn integration.",
  perAccount: "{count} per account",
  enterAtLeastOneCallToAction: "Enter at least one call to action",
  selectAtLeastOneAccountForPost: "You need to select at least one account for this post",
  targetAudience: "Target Audience",
  brandIdentity: "Brand Identity",
  addFromLibrary: "Add a file from my library",
  taskAttachmentDragDrop:
    "You can also drag and drop an image in JPG, PNG, or WEBP format inside the input box.",
  wordpressWebsiteUrl: "WordPress Website URL",
  continueToAuthz: "Continue to Authorization",
  authorizeApp: "Authorize Application",
  wpAuthzGuide:
    "A new tab will open where you can:|Log in to your WordPress admin panel|Review and approve the application|Copy the generated application password",
  openAuthzPage: "Open Authorization Page",
  doneWithAuthz: "I've completed authorization",
  enterCredentials: "Enter Your Credentials",
  maxImagesReached: "Maximum of {max} images allowed for {platform}",
  removeImageToAddMore: "Remove an image to save post content",
  maxVideosReached: "Maximum of {max} videos allowed for {platform}",
  removeVideoToAddMore: "Remove a video to save post content",
  maxMediaReached:
    "Maximum of {maxImages} images and {maxVideos} videos allowed for {platform}",
  removeMediaToAddMore: "Remove an image or video to save post content",
  scheduleContentPublishedTitle: "Know When Your Posts Go Live",
  scheduledContentPublishedDescription:
    "Get email notifications when your scheduled posts go live.",
  competitorReport: "Weekly Competitor Insights",
  competitorReportDescription:
    "Receive weekly emails with reports on your competitors’ SEO and social media activity.",
  viewFullImage: "View Full Image",
  noImagePreviewTitle: "No Image Preview Available",
  noImagePreviewDescription:
    "The image preview is not available at the moment. This could be due to an issue with the source website or the image may no longer be accessible.",
  activity: "Activity",
  noActivity: "No activity",
  noPostsWeek: "No posts this past week",
  postsThisWeek: "{count} posts this past week",
  contentPostedTitle: "Content Posted",
  taskContentPostedSuccess: "Your content has been posted successfully.",
  taskContentScheduledSuccess:
    "Your content has been scheduled and will be posted at the specified time.",
  postCompleteConfirmation: "Do you want create another post or return to the post?",
  createNewContent: "Create New Content",
  returnToContent: "Return to Content",
  taskNoContent: "No content found for the selected task.",
  confirmResetContentGeneration: "Reset and create new content?",
  contentFilterPlaceholder: "Find the content you want to generate",
  workingOnContent: "Working on your content",
  contentAlmostReady: "Your content is almost ready",
  contentReady: "Your content is ready",
  quickTaskActionDescription:
    "Use one of the actions to edit, share it now or later. or create more content",
  addMedia: "Add media",
  quickActions: "Quick Actions",
  postNow: "Post Now",
  postLater: "Post Later",
  v2ChatInstruction: "Type something to get started",
  openApp: "Open App",
  openChat: "Open Chat",
  startNewConversation: "Start new conversation",
  scheduledAndPostedAt: "Scheduled for {scheduleTime} and posted at {postTime}",
  customLoaderText1: "Getting your data",
  customLoaderText2: "Authenticating your request",
  customLoaderText3: "Securing the response",
  customLoaderText4: "Almost there",
  configureIntegration: "Configure Integration",
  manageIntegration: "Manage Integration",
  uploadMedia: "Upload Media",
  selectVideo: "Select Video",
  videoPreview: "Video Preview",
  videoTooLarge: "Video file is too large (max {max}MB)",
  videoFormatNotSupported: "Video format not supported",
  processingVideo: "Processing video...",
  dragAndDropVideo: "Drag and drop your video here",
  mixedMediaTitle: "Mixed Media Limitation",
  mixedMediaWarning:
    "Most social media platforms don't support posting both images and videos together. You'll need to remove either images or videos before posting to Facebook, Twitter, TikTok or LinkedIn.",
  retry: "Retry",
  loadingError: "Some details could not be loaded. Please try again",
  maxSocialAccountsReached: "Maximum Social Accounts Reached",
  maxSocialAccountsReachedMessage:
    "You have reached the maximum number of {max} social media accounts.",
  whatsNew: "What's New",
  whatsNewSubtitle: "Latest updates and improvements to our platform",
  loadingWhatsNew1: "Loading updates",
  loadingWhatsNew2: "Fetching latest features",
  loadingWhatsNew3: "Preparing content",
  noUpdateTitle: "No updates available",
  noUpdateDescription:
    "Check back soon for the latest features and improvements to our platform",
  refresh: "Refresh",
  moreDetails: "More Details",
  removeImageTitle: "Remove Image",
  removeImageDescription: "Are you sure you want to remove this attachment?",
  maximize: "Maximize",
  chatbotName: "My Super Agent",
  myRecentContent: "My recent content",
  mfaSecurity: "Security",
  multiFactorAuthentication: "Multi-Factor Authentication",
  enableMfa: "Enable Multi-Factor Authentication",
  mfaDescription:
    "Add an extra layer of security to your account with multi-factor authentication.",
  mfaRedirectingToSetup: "You'll be redirected to complete your MFA setup",
  mfaDisabled: "Multi-factor authentication disabled",
  buttonsSavingChanges: "Saving...",
  scheduledContentMissingIntegrationMessage:
    " This content will not be posted because there is no active integration or it has been disabled. Click the event to reconfigure the integration.",
  missingIntegrationAlertMessage:
    "There is no integration for this platform or the integration has been disabled",
  maxFilesExceeded: "You can upload a maximum of {max} files at a time",
  runsOnceOn: "Runs once on {time}",
  runsEvently: "Runs every {interval}",
  sortBy: "Sort by",
  fileSortByName: "Name",
  newestFirst: "Newest First",
  oldestFirst: "Oldest First",
  postToTikTok: "Post to TikTok",
  postedTikTok: "Posted to TikTok",
  postToYouTube: "Post to YouTube",
  postAsYouTubeShort: "Post as YouTube Short",
  postAsYouTubeShortHint:
    "#Shorts will be appended to the description. Applies to vertical videos up to 60 seconds.",
  postedYouTube: "Posted to YouTube",
  errorPostingToYouTube: "Error posting to YouTube",
  visibility: "Visibility",
  emptyMediaMessage: "Add at least two photos or a video before posting to TikTok.",
  invalidMediaMessage:
    "Photo posts require at least 2 photos. Add another photo or switch to a video.",
  tiktokVideoRequired:
    "TikTok posts require a video. Please add a video to continue. Image posts are not supported yet.",
  category: "Category",
  madeForKids: "Made for kids",
  videoRequiredToPost: "Please add a video before posting to YouTube.",
};
